import { SET_MODEL_CHANGED } from "@/store/shared/mutations"

const EXCLUDED_INTERESTS_APPEND = (state, payload) => {
  if (Array.isArray(payload)) {
    payload.forEach(item => {
      state.model.audience.targeting.excludedInterests.push(item)
    })
  } else {
    state.model.audience.targeting.excludedInterests.push(payload)
  }

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_INTERESTS_REMOVE = (state, payload) => {
  const ids = []

  if (Array.isArray(payload)) {
    payload.forEach(item => {
      ids.push(item.id)
    })
  } else {
    ids.push(payload.id)
  }

  state.model.audience.targeting.excludedInterests = state.model.audience.targeting.excludedInterests.filter(
    i => ids.indexOf(i.id) < 0
  )

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_GEO_LOCATION_APPEND = (state, payload) => {
  state.model.audience.targeting.excludedGeoLocations.push(payload)

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_GEO_LOCATION_REMOVE = (state, payload) => {
  state.model.audience.targeting.excludedGeoLocations = state.model.audience.targeting.excludedGeoLocations.filter(
    i => i.key !== payload.key
  )

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_GEO_LOCATION_UPDATE = (state, payload) => {
  state.model.audience.targeting.excludedGeoLocations = state.model.audience.targeting.excludedGeoLocations.map(
    i => (i.key === payload.key ? payload : i)
  )

  SET_MODEL_CHANGED(state, true)
}

const GEO_LOCATION_APPEND = (state, payload) => {
  state.model.audience.targeting.geoLocations.push(payload)

  SET_MODEL_CHANGED(state, true)
}

const GEO_LOCATION_REMOVE = (state, payload) => {
  state.model.audience.targeting.geoLocations = state.model.audience.targeting.geoLocations.filter(
    i => i.key !== payload.key
  )

  SET_MODEL_CHANGED(state, true)
}

const GEO_LOCATION_UPDATE = (state, payload) => {
  state.model.audience.targeting.geoLocations = state.model.audience.targeting.geoLocations.map(
    i => (i.key === payload.key ? payload : i)
  )

  SET_MODEL_CHANGED(state, true)
}

const INTERESTS_APPEND = (state, payload) => {
  const { group, items } = payload

  if (Array.isArray(items)) {
    items.forEach(item => {
      group.items.push(item)
    })
  } else {
    group.items.push(items)
  }

  state.model.audience.targeting.interestsGroups = state.model.audience.targeting.interestsGroups.map(
    g => (g.id !== group.id ? g : group)
  )

  SET_MODEL_CHANGED(state, true)
}

const INTERESTS_REMOVE = (state, payload) => {
  const { group, items } = payload
  const ids = []

  if (Array.isArray(items)) {
    items.forEach(item => {
      ids.push(item.id)
    })
  } else {
    ids.push(items.id)
  }

  group.items = group.items.filter(i => ids.indexOf(i.id) < 0)

  state.model.audience.targeting.interestsGroups = state.model.audience.targeting.interestsGroups.map(
    g => (g.id !== group.id ? g : group)
  )

  SET_MODEL_CHANGED(state, true)
}

const INTERESTS_GROUP_APPEND = (state, payload) => {
  state.model.audience.targeting.interestsGroups.push(payload)

  SET_MODEL_CHANGED(state, true)
}

const INTERESTS_GROUP_REMOVE = (state, payload) => {
  state.model.audience.targeting.interestsGroups = state.model.audience.targeting.interestsGroups.filter(
    i => i.id !== payload.id
  )

  SET_MODEL_CHANGED(state, true)
}

export {
  EXCLUDED_GEO_LOCATION_APPEND,
  EXCLUDED_GEO_LOCATION_REMOVE,
  EXCLUDED_GEO_LOCATION_UPDATE,
  EXCLUDED_INTERESTS_APPEND,
  EXCLUDED_INTERESTS_REMOVE,
  GEO_LOCATION_APPEND,
  GEO_LOCATION_REMOVE,
  GEO_LOCATION_UPDATE,
  INTERESTS_APPEND,
  INTERESTS_GROUP_APPEND,
  INTERESTS_GROUP_REMOVE,
  INTERESTS_REMOVE,
}
